import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import React from 'react';
import cn from 'classnames';
import { useIsInBottomSheet } from '../../providers';
import { useCloseHostingBottomSheetPage } from '../OverlayContext/hooks/useCloseHostingBottomSheetPage';
import styles from './Menu.module.scss';
import { MenuContextualAction } from './MenuContextualAction';
import { MenuPromotionalAction } from './MenuPromotionalAction/MenuPromotionalAction';
export function MenuFooter(param) {
    let { items, className, closeBottomSheetOnAction } = param;
    const isInBottomSheet = useIsInBottomSheet();
    const closeHostingPage = useCloseHostingBottomSheetPage();
    if (items.length === 0) return null;
    const closeHostingPageAfterActionSettles = (action)=>function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            void Promise.resolve(action(...args)).then(()=>{
                if (closeBottomSheetOnAction && isInBottomSheet) {
                    closeHostingPage();
                }
            });
        };
    return /*#__PURE__*/ _jsx("div", {
        className: cn(styles.footer, className),
        children: items.map((item, index)=>{
            switch(item.variant){
                case 'contextualAction':
                    return /*#__PURE__*/ _createElement(MenuContextualAction, _object_spread_props(_object_spread({}, item.props), {
                        key: index,
                        onClick: item.props.onClick && closeHostingPageAfterActionSettles(item.props.onClick),
                        onMouseDown: item.props.onMouseDown && closeHostingPageAfterActionSettles(item.props.onMouseDown)
                    }));
                case 'promotionalAction':
                    return /*#__PURE__*/ _createElement(MenuPromotionalAction, _object_spread_props(_object_spread({}, item.props), {
                        key: index,
                        onClick: item.props.onClick && closeHostingPageAfterActionSettles(item.props.onClick),
                        onMouseDown: item.props.onMouseDown && closeHostingPageAfterActionSettles(item.props.onMouseDown)
                    }));
            }
        })
    });
}
